import { GraphQLFieldConfig, GraphQLNonNull } from 'graphql'
import { Context } from '../shared'
import { ATOAttackPageType, ATOAttackPage } from '../types/ato-attack-page'
import {
  atoAttackPagingArgs,
  ATOAttackPagingArgs
} from '../types/ato-attack-paging-args'

export const atoAttacks: GraphQLFieldConfig<any, Context> = {
  description: 'Get a page of ATO attacks',
  type: new GraphQLNonNull(ATOAttackPageType),
  args: atoAttackPagingArgs,
  async resolve(
    _source,
    { limit }: ATOAttackPagingArgs,
    _context: Context
  ): Promise<Partial<ATOAttackPage>> {
    return {
      total: limit,
      items: []
    }
  }
}
